export default "__VITE_ASSET__C95ROJlo__"